import type { ThemeMode } from './themeRegisters.js';

/**
 * App-wide active theme store. ScreenFrame writes; ThemeProvider (@beatq/ui)
 * subscribes so the wrapper `data-theme` and `documentElement` stay in sync
 * without a shared→ui import cycle.
 */
let activeTheme: ThemeMode = 'standard';
const listeners = new Set<() => void>();

function syncDocument(theme: ThemeMode): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
}

export function getActiveTheme(): ThemeMode {
  return activeTheme;
}

export function setActiveTheme(theme: ThemeMode): void {
  const changed = activeTheme !== theme;
  activeTheme = theme;
  syncDocument(theme);
  if (!changed) return;
  listeners.forEach((listener) => listener());
}

export function subscribeActiveTheme(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
